// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/payments/salary-payments",
  Detail: "/pyr/payments/salary-payments/{id}",
  DetailEmployee: "/pyr/payments/salary-payments/{id}/details",
  ListShort: "/pyr/payments/salary-payments/short",
  Create: "/pyr/payments/salary-payments",
  Update: "/pyr/payments/salary-payments",
  ApprovalStatus: "/pyr/payments/salary-payments/approval-status",
  BankTransfer: "/pyr/payments/salary-payments/bank-transfer",
};
